'use strict';

import ErrorType from '../constants/error-type';
var device = require('../util/device');

module.exports = (function () {

	function validate(metadata, videoUrls) {
		var error;
		if (metadata.liveStartTimeUTC && !metadata.rights) {
			error = {
				name: ErrorType.LIVE_NOT_STARTED_ERROR,
				timestamp: metadata.liveStartTimeUTC
			};
		} else if (!metadata.rights) {
			error = {
				name: ErrorType.RIGHTS_EXPIRED_ERROR
			};
		} else if (metadata.rights.drmCopyProtection && !device.isFlashCapable() && _onlyHds(videoUrls)) {
			error = {
				name: ErrorType.DRM_PROTECTION_ERROR
			};
		}

		return error;

	}

	function _onlyHds(videoUrls) {
		return !(videoUrls.dash264 || videoUrls.hls) && videoUrls.hds !== undefined;
	}

	return {
		validate: validate
	};
})();



// WEBPACK FOOTER //
// ./src/js/util/validator.js